import { render } from "./SchoolStudentForm.vue?vue&type=template&id=a0148a9e&scoped=true"
import script from "./SchoolStudentForm.vue?vue&type=script&lang=js"
export * from "./SchoolStudentForm.vue?vue&type=script&lang=js"

import "./SchoolStudentForm.vue?vue&type=style&index=0&id=a0148a9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0148a9e"]])

export default __exports__